import SearchBlock from "./search";
import SearchUsers from "./search-users";

export {
    SearchUsers
}

export default SearchBlock;